export enum EnvironmentType {
    Develop = 1,
    Qa,
    Production
}

export enum HeaderEnum {
    NoAuthenticate = 1,
    NoShowLoading,
    Pagination,
    Encryption
}

export enum EncryptionEnum {
    AES = 'AES-ENC',
    RSA = 'RSA-ENC',
    JWT = 'JWT-ENC',
    JWE = 'JWE-ENC'
}

export enum IconEnum {
    AweSomeFont = 1,
    Svg,
    SvgLocal,
    MaterialDesign
}

export enum OptionMenuEnum {
    Module = 1,
    SubModule,
    Screen,
    Function
}

export enum DataEnum {
    Text = 1,
    Number,
    Decimal,
    Boolean,
    Date,
    Email,
    URL
}

export enum ApiEnum {
    Security = 1,
    Rest,
    Sales,
}

export enum PlatformEnum {
    All = 1,
    Web,
    Movil,
}

export enum PermissionEnum
{
  TI = 'TI',
  Administrar = 'Administrar',
  Consultar = 'Consultar',
  Agregar = 'Agregar',
  Editar = 'Editar',
  Eliminar = 'Eliminar',
  Exportar = 'Exportar',
}

export enum ScreenEnum
{
  Ninguno = 0,
  Perfil = 'Perfil',
  Usuario = 'Usuario',
  Home = 'Home',
  Modulo = 'Modulo',
  PlantillaCorreo = 'PlantillaCorreo',
  Parametros = 'Parametros',
  Submodulo = 'Submodulo',
  Pantalla = 'Pantalla',
  TipoUsuario = 'TipoUsuario',
  // Módulo de Transportes
  Operador = 'Operador',
  Unidad = 'Unidad',
  Tanque = 'Tanque',
  Cliente = 'Cliente',
  Deposito = 'Deposito',
  Gasto = 'Gasto',
  Ruta = 'Ruta',
  GuiaRuta = 'GuiaRuta',
  Pago = 'Pago',
  Cierre = 'Cierre',
  Facturacion = 'Facturacion',
  // Módulo de Reportes
  DashboardSeguimientoOrdenesCarga = 'DashboardSeguimientoOrdenesCarga',
  EstadisticasGenerales = 'EstadisticasGenerales',
  ReporteDetalleOperador = 'ReporteDetalleOperador',
  ReporteRechazosFletes = 'ReporteRechazosFletes',
  ReporteDepositos = 'ReporteDepositos',
  ReporteGastos = 'ReporteGastos',
  ReporteFletesCliente = 'ReporteFletesCliente',
  ReporteGeneralOperaciones = 'ReporteGeneralOperaciones',
  ReporteBalanzaGanancias = 'ReporteBalanzaGanancias'
}

export enum StatusDepositsEnum
{
  Solicitud = 1,
  Realizado = 2,
  Rechazado = 3
}

export enum StatusRoutesEnum
{
  EnRuta = 1,
  Pagado = 2,
  Validado = 3,
  Rechazado = 4,
  RechazoParcial = 5,
  Completado = 6
}

// Estatus para Cierres de Ruta
export enum StatusRouteClosuresEnum
{
  Completado = 1,
  Cancelado = 2
}

// Estatus de Gastos
export enum StatusExpensesEnum
{
  PorAutorizar = 1,
  Autorizado = 2,
  Rechazado = 3
}

export enum ResponseStatusEnum {
    OK = 200,
    CREATED = 201,
    NO_CONTENT = 204,
    PARTIAL_CONTENT = 206,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500
}

export enum ResponseStatusMessageEnum {
    OK = "",
    NO_CONTENT = "La respuesta no devolvió contenido",
    PARTIAL_CONTENT = "Falta de información en la petición",
    BAD_REQUEST = "Ocurrió un error interno al realizar la petición",
    UNAUTHORIZED = "No tienes autorización para acceder al recurso",
    NOT_FOUND = "Información del servicio no encontrada",
    INTERNAL_SERVER_ERROR = "Error interno del servidor"
}


export enum UserFunctionsEnum {
    ChangePassword = 1,
    LogOut, LogOutMask
}



